export const ContentWidth = {
  Fluid: 'fluid',
  Boxed: 'boxed',
} as const

export const NavbarType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const FooterType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const

export const AppContentLayoutNav = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
} as const

export const HorizontalNavType = {
  Sticky: 'sticky',
  Static: 'static',
  Hidden: 'hidden',
} as const
